import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { ReactSortable } from "react-sortablejs";
import {
    getSubscriptionWorkoutsSagaAction,
    removeSubscriptionWorkoutSagaAction,
    sortSagaAction
} from "../../redux/sagaActions";

const SubscriptionWorkoutsCount = () => {
    const dispatch = useDispatch();
    const subscription_workouts_count = useSelector(state => state.subscription_workouts_count);

    const [list, setList] = useState([]);

    // Смена позиций
    const changePositions = ({ oldInd, newInd }) => {
        // Копируем начальный массив
        let copy = [...subscription_workouts_count];

        let cut = copy.splice(oldInd, 1)[0];
        copy.splice(newInd, 0, cut);

        dispatch(sortSagaAction({
            table: 'workouts_count',
            new_order: JSON.stringify(copy.map(elem => elem.id))
        }));

        setList([]);
    };

    return (
        <div className="settings">
            <ReactSortable
                list={ list }
                setList={ setList }
                handle={ '.control--move' }
                onEnd={ event => changePositions({ oldInd: event.oldIndex, newInd: event.newIndex }) }
            >
                {
                    subscription_workouts_count.map(elem => {
                        return (
                            <div className="setting" key={ elem.id }>
                                <div className="controls">
                                    <i className="control control--edit" onClick={ () => {
                                        dispatch(getSubscriptionWorkoutsSagaAction({ id: elem.id }));
                                    } } />
                                    <i className="control control--move" />
                                    <i className="control control--remove" onClick={ () => {
                                        if (window.confirm('Вы действительно хотите удалить это количество занятий?')) {
                                            dispatch(removeSubscriptionWorkoutSagaAction({ id: elem.id }));
                                        }
                                    } } />
                                </div>
                                <div className="setting__caption">{ elem.name }</div>
                            </div>
                        )
                    })
                }
            </ReactSortable>
        </div>
    );
};

export default SubscriptionWorkoutsCount;